import React from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { iconColor } from 'utils/helpers'

export const VerticalSeparatorIcon = () => {
    const { darkMode } = useSelector((state: RootState) => state.globals)
    const fill = iconColor(darkMode)
    {
        return <svg className="vertical-separator-icon" width="1" height="22" viewBox="0 0 1 22" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <rect width="1" height="22" />
        </svg>
    }
}

